export const replaceEmptyStringsWithUndefined = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (typeof obj === 'string') {
    return obj === '' ? undefined : obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(replaceEmptyStringsWithUndefined);
  }

  if (typeof obj === 'object') {
    const result: any = {};
    for (const [key, value] of Object.entries(obj)) {
      const processedValue = replaceEmptyStringsWithUndefined(value);
      result[key] = processedValue;
    }
    return result;
  }

  return obj;
};

export const processThemeTokens = (themeTokens: any): any => {
  if (!themeTokens) {
    return themeTokens;
  }

  return replaceEmptyStringsWithUndefined(themeTokens);
};
